import { MULTIRX_LOGO_SRC } from '../dashboard/multirxHero.js';

/** Placeholder chargement : logo MultiRX + balayage reflet épée. */
export function createMultirxShineLoader(label = 'Chargement…'): HTMLElement {
  const el = document.createElement('div');
  el.className = 'multirx-shine-loader';
  el.setAttribute('role', 'status');
  el.setAttribute('aria-live', 'polite');
  el.innerHTML = `
    <div class="multirx-shine-loader__veil" aria-hidden="true"></div>
    <div class="multirx-shine-loader__logo-wrap" style="--multirx-shine-mask: url('${MULTIRX_LOGO_SRC}')">
      <img class="multirx-shine-loader__logo" src="${MULTIRX_LOGO_SRC}" alt="" draggable="false" />
      <span class="multirx-shine-loader__shine" aria-hidden="true">
        <span class="multirx-shine-loader__beam"></span>
      </span>
    </div>
    <p class="multirx-shine-loader__label">${label}</p>`;
  return el;
}
